import {
  START_REQUEST_CATALOGS,
  REQUEST_CATALOGS_SUCCESS,
  REQUEST_CATALOGS_FAILED,
} from '../actions/catalogs';

const CATALOGS_INITIAL_STATE = {
  response: {},
  error: false,
  hasData: false,
};

export default (state = CATALOGS_INITIAL_STATE, action) => {
  switch (action.type) {
    case START_REQUEST_CATALOGS:
      return {
        ...state,
        response: {},
        error: false,
      };
    case REQUEST_CATALOGS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        error: false,
        hasData: true,
      };
    case REQUEST_CATALOGS_FAILED:
      return {
        ...state,
        response: action.payload,
        error: true,
        hasData: false,
      };
    default:
      return state;
  }
};
